//--- React
import { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
//--- Ant Design
import { Col, Row, Tabs } from "antd";
//--- Project
import { TEST_RIDE_SUMMARY } from "components/Common/Grafana/Constants";
import { UNITS } from "components/Common/Constants";
import FullGraphsModal from "./fullGraphsModal";
import panelList from "../panelList.json";
import GetIframe from "components/Common/Grafana/GetIframe";

const DecelerationAnalytics = ({ baseUrl, baseFilterObject }) => {
  const [selectedTab, setSelectedTab] = useState("20-0");
  const vehicleDetails = useSelector((state) => state.eol.vehicleDetails);
  const tripSummary = useSelector((state) => state.testRide.tripSummary);
  const [decelerationList, setDecelerationList] = useState([]);

  useEffect(() => {
    setDecelerationList(panelList?.deceleration);
  }, []);

  const baseFilterValues = useMemo(() => {
    return { ...baseFilterObject, dccl_range: selectedTab };
  }, [baseFilterObject, selectedTab]);

  const onChangeTab = (value) => {
    setSelectedTab(value);
  };

  const items = [
    {
      key: "20-0",
      label: "20-0",
    },
    {
      key: "40-0",
      label: "40-0",
    },
    {
      key: "60-0",
      label: "60-0",
    },
    {
      key: "80-0",
      label: "80-0",
    },
  ];

  const subContent = (
    <Row gutter={[16, 16]} justify="end" className="mt105">
      <Col xs={12} sm={12} md={12} lg={4} xl={4} className="flex-center">
        Max:{" "}
        <span className="ml025 mr025 bold">
          {tripSummary?.minAccelerationMps2}{" "}
        </span>
        {UNITS.METER_PER_SECONDS_SQUARED}
      </Col>
      <Col xs={12} sm={12} md={12} lg={4} xl={4} className="flex-center">
        Min:{" "}
        <span className="ml025 mr025 bold">
          {tripSummary?.maxAccelerationMps2}{" "}
        </span>
        {UNITS.METER_PER_SECONDS_SQUARED}
      </Col>
    </Row>
  );

  return (
    <>
      {subContent}
      <Row className="mt105 pd0">
        <Col span={24}>
          <Tabs
            activeKey={selectedTab}
            items={items}
            type="card"
            onChange={onChangeTab}
            className="celeration-tab-view"
            tabBarExtraContent={
              <FullGraphsModal
                modalTitle="Deceleration"
                vehicleDetails={vehicleDetails}
                baseUrl={baseUrl}
                baseFilterObject={baseFilterValues}
                variableKeys={TEST_RIDE_SUMMARY.DCCL_VARIABLES}
                chartList={["DecelerationDistance", "DecelerationDuration"]}
              />
            }
          />

          <Row className="pd0">
            {decelerationList?.map((panel, index) => (
              <Col key={index} span={24}>
                <Row gutter={[12, 12]} className="pdtb05">
                  <Col span={24} id={`${panel.title}-timeseries`}>
                    <GetIframe
                      title={panel.title}
                      url={baseUrl}
                      panelId={
                        TEST_RIDE_SUMMARY.PANEL_ID[panel.var_name]["timeSeries"]
                      }
                      variableObject={baseFilterValues}
                      variableKeys={TEST_RIDE_SUMMARY.DCCL_VARIABLES}
                      width="100%"
                      height="240"
                      divId={`${panel.title}-timeseries`}
                    />
                  </Col>
                </Row>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default DecelerationAnalytics;
